import { render } from "./index.vue?vue&type=template&id=2d4e4e22"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/campaigns-category/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d4e4e22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d4e4e22', __exports__)) {
    api.reload('2d4e4e22', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2d4e4e22", () => {
    api.rerender('2d4e4e22', render)
  })

}


export default __exports__